import React from 'react';

function AboutPage() {
  const currentEmployees = [
    { name: 'Jeny Patel', qualification: 'M.Pharm', status: 'present' },
    { name: 'Jay Garambha', qualification: 'M.Pharm', status: 'present' },
    { name: 'Shaileash Teli', qualification: 'M.Pharm', status: 'present' },
    { name: 'Darshan Vekariya', qualification: 'M.Pharm', status: 'present' }
  ];

  const pastEmployees = [
    { name: 'Denis Naina', qualification: 'M.Pharm', status: 'past' },
    { name: 'Dhrusha Patel', qualification: 'M.Pharm', status: 'past' }
  ];

  return (
    <main className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <h2>About Disha Medical Store</h2>
        <p className="tagline">Serving Your Health & Wellness Since 2000</p>
      </section>

      {/* Our Story */}
      <section className="our-story">
        <h3>📖 Our Story</h3>
        <div className="story-content">
          <p>
            <strong>Disha Medical Store</strong> was established in <strong>2000</strong> with a vision to make quality medicines and Ayurvedic products accessible to our community. What started as a small-scale venture to serve the locality has grown into a trusted name in pharmaceutical retail.
          </p>
          <p>
            Over the past <strong>25 years</strong>, we have witnessed remarkable growth driven by the increasing demand for quality medicines and our commitment to expanding our product range. We pride ourselves on offering a wide selection of <strong>pharmaceuticals, Ayurvedic remedies, herbal supplements, and wellness products</strong> that cater to diverse health needs.
          </p>
          <p>
            Our success is built on three pillars: <strong>Trust, Quality, and Service Excellence</strong>. We are dedicated to helping our customers achieve better health outcomes through expert guidance and authentic products.
          </p>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-us-about">
        <h3>✨ Why Choose Us?</h3>
        <div className="features-list">
          <div className="feature">
            <span className="feature-icon">✓</span>
            <h4>25 Years of Experience</h4>
            <p>Trusted by thousands of customers across the locality</p>
          </div>
          <div className="feature">
            <span className="feature-icon">✓</span>
            <h4>Authentic Products</h4>
            <p>100% genuine medicines from authorized distributors</p>
          </div>
          <div className="feature">
            <span className="feature-icon">✓</span>
            <h4>Expert Guidance</h4>
            <p>Qualified pharmacists available for consultation</p>
          </div>
          <div className="feature">
            <span className="feature-icon">✓</span>
            <h4>Wide Range</h4>
            <p>Over 1000+ products including Ayurvedic and herbal medicines</p>
          </div>
        </div>
      </section>

      {/* Our Team */}
      <section className="our-team">
        <h3>👥 Our Team</h3>
        <p className="team-intro">Our dedicated team of qualified pharmacists is committed to your health and wellness.</p>
        
        <div className="team-container">
          <div className="team-section">
            <h4 className="team-title current">Currently Serving</h4>
            <div className="team-grid">
              {currentEmployees.map((employee, idx) => (
                <div key={idx} className="team-card current-card">
                  <div className="team-avatar">👤</div>
                  <h5>{employee.name}</h5>
                  <p className="qualification">{employee.qualification}</p>
                  <span className="badge current-badge">Active</span>
                </div>
              ))}
            </div>
          </div>

          <div className="team-section">
            <h4 className="team-title past">Past Team Members</h4>
            <div className="team-grid">
              {pastEmployees.map((employee, idx) => (
                <div key={idx} className="team-card past-card">
                  <div className="team-avatar">👤</div>
                  <h5>{employee.name}</h5>
                  <p className="qualification">{employee.qualification}</p>
                  <span className="badge past-badge">Past Member</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Location */}
      <section className="location-section">
        <h3>📍 Visit Us</h3>
        
        <div className="map-full-width">
          <iframe
            title="Disha Medical Store Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.481992764919!2d72.96074038622234!3d22.561069408726695!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e4fa839a977d9%3A0xa361ea04952ecc9!2sDISHA%20MEDICAL%20STORE!5e0!3m2!1sen!2sca!4v1761894930409!5m2!1sen!2sca"
            width="100%"
            height="500"
            style={{ border: 0, borderRadius: '12px' }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        <div className="location-info-card">
          <div className="info-content">
            <h4>Disha Medical Store</h4>
            <div className="info-details">
              <p>
                <strong>📍 Address:</strong><br/>
                Shop No. 8, Mahavir Chambers<br/>
                Mahavir Marg, Anand 388001<br/>
                Gujarat, India
              </p>
              <p>
                <strong>📞 Phone:</strong><br/>
                <a href="tel:8401477362">8401477362</a>
              </p>
              <p>
                <strong>✉️ Email:</strong><br/>
                <a href="mailto:dishamedicalstore9@gmail.com">dishamedicalstore9@gmail.com</a>
              </p>
              <p>
                <strong>🕐 Operation:</strong><br/>
                Serving since 2000 (25 years)
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta">
        <h3>Ready to Shop?</h3>
        <p>Explore our wide range of medicines and wellness products online or visit us in person!</p>
        <button className="btn-shop" onClick={() => window.location.href = '/'}>
          Start Shopping 🛍️
        </button>
      </section>
    </main>
  );
}

export default AboutPage;